export default __webpack_public_path__ + "static/media/44.96f0f42e.jpg";